// extracted by mini-css-extract-plugin
export var container = "_ih-0";
export var dotAnimation = "_ih-2";
export var dotsLoading = "_ih-1";